<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>
    <div class="container-fluid mt--8">
      <div class="card shadow">
        <div class="row p-3">
          <div class="col-lg-6 col-6 mb-1" v-if="is_allowed_create">
            <button v-if="is_allowed_delete"
              :disabled="!showActionDelete"
              v-on:click="showConfirmationModal = true"
              class="btn btn-danger"
            >
              <i class="fa fa-trash"></i> Delete
            </button>
            <button
              v-on:click="onEditRow"
              :disabled="!showActionEdit"
              class="btn btn-primary">
              <i class="fa fa-edit"></i> Edit
            </button>
            <button v-on:click="onCreateNewPromo" class="btn btn-primary">
              Create Promo
            </button>
          </div>
          <div class="col-6 pull-right">
            <div class="row">
              <label class="col-4 col-form-label form-control-label text-right">
                brand
              </label>
              <div class="col-8">
                <model-list-select
                  :list="brandCodeOption"
                  v-model="watch_brand_code"
                  option-value="value"
                  option-text="text"
                  placeholder="select merchant item">
                </model-list-select>
              </div>
            </div>
          </div>
        </div>
        <div v-if="message">
            
          <base-alert 
            :type="message.type" 
            :dismissible="true" 
            @resetMessage="resetMessage">{{
            message.message
          }}</base-alert>
        </div>
        <div v-if="deleteMessages">
          <base-alert
            :type="deleteMessages[0].type"
            :dismissible="true"
            v-for="(row, index) in deleteMessages"
            :key="index"
            >{{ row.message }}</base-alert
          >
        </div>
        <vue-bootstrap4-table
          :rows="rows"
          :columns="columns"
          :config="config"
          :classes="classes"
          @on-select-row="onSelectRow"
          @on-unselect-row="onSelectRow"
          @refresh-data="onRefreshData"
        >
          <template slot="is_giid_only_column" slot-scope="props">
            <label v-if="props.cell_value == 0"> False </label>
            <label v-if="props.cell_value == 1"> True </label>
          </template>
        </vue-bootstrap4-table>
      </div>
    </div>
    <modal :show.sync="showConfirmationModal" modalClasses="modal-sm">
      <h3>Are you sure to delete these items?</h3>
      <ul>
        <li v-for="(row, index) in selectedItems" :key="index">
          {{ row.promotion_name }}
        </li>
      </ul>
      <template slot="footer">
        <div class="row">
          <div class="col-lg-6">
            <base-button
              type="link"
              class="ml-auto btn-block"
              @click="showConfirmationModal = false"
              >No
            </base-button>
          </div>
          <div class="col-lg-6">
            <base-button
              type="primary"
              class="ml-auto btn-block"
              @click="onDeleteRow"
              >Yes
            </base-button>
          </div>
        </div>
      </template>
    </modal>
    <modal :show.sync="showModalCreate" modal-classes="modal-lg">
      <h3 slot="header" class="modal-title" id="modal-title-default">
        {{ this.titlePopup }} Promo Config
      </h3>
      <form @submit.prevent>
        <div class="row">
          <div class="col-lg-6">
            <div class="form-group has-label">
              <label class="form-control-label" style="color: red; font-size: 12px;" v-if="isDisabledUpdate">
                *Unable to edit cause this promo has been started
              </label>
              <label class="form-control-label">
                Brand Code
              </label>
              <model-list-select
                :list="brandCodeOption"
                v-model="watch_brand_code"
                option-value="value"
                option-text="text"
                placeholder="select item"
                :isDisabled="isBrandCodeDisabled"
              >
              </model-list-select>
            </div>
          </div>

        </div>
        <div class="row">
          <div class="col-lg-6">
            <label class="form-control-label"> Promotion Type</label>
            <model-list-select
              :list="allPromoType"
              v-model="watch_promo_type"
              option-value="value"
              option-text="text"
              placeholder="select promo type"
              :isDisabled="isPromoTypeDisabled"
            >
            </model-list-select>      
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <base-input
              alternative=""
              label="Promotion Name"
              input-classes="form-control"
              v-model="GlobalPromoModel.promotion_name"
              :disabled="isDisabledUpdate"
            />
          </div>
        </div>
        <div class="row" v-if="IsMaxChancePerDayShow">
          <div class="col-lg-6">
            <base-input
              alternative=""
              label="Max Chance Per Day"
              input-classes="form-control"
              v-model="GlobalPromoModel.max_chance_per_day"
               type="number"
              :disabled="MaxChancePerDayInputDisabled"
            />
          </div>
        </div>
        <div class="row" v-if="IsMaxWinPerPersonShow">
          <div class="col-lg-6">
            <base-input
              alternative=""
              label="Max Win Per Person"
              input-classes="form-control"
              v-model="GlobalPromoModel.max_win_per_person"
               type="number"
              :disabled="MaxWinPerPersonInputDisabled || isDisabledUpdate"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="form-group has-label">
              <label class="form-control-label"> Is Only Giid Verified </label>
              <base-checkbox
                alternative=""
                input-classes="form-control"
                v-model="GlobalPromoModel.is_giid_only"
                value="true"
                :disabled="isDisabledUpdate"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <label class="form-control-label"> Rules </label>
            <label class="form-control-label" v-if="isLabelUPCInputRegularShow" style="color:red;">(Please Select only one Rules UPC Input Regular)</label>
            <label class="form-control-label" v-if="isLabelProgressiveMGMShow" style="color:red;">(Only one Rules with the same Input_count for Major Prize)</label>
            <label class="form-control-label" v-if="isLabelDailyLoginWarningShow" style="color:red;">(Cannot insert more than one rules with same input count)</label>
            <multiselect
              v-model="watch_rules_id"
              tag-placeholder="Add this as Rules"
              placeholder="Search or add Rules"
              label="rules_name"
              track-by="id"
              :options="selectedRulesOption"
              :multiple="isMultiSelect"
              :taggable="true"
              @remove="unSelectItem"
              :disabled="isDisabledUpdate"
            >
            </multiselect>
            <label class="form-control-label" style="color: red; font-size: 12px;" v-if="this.watch_promo_type == 15">* Add minimum 4 rules and maximum 9 rules including try again </label>
            <label class="form-control-label" style="color: red; font-size: 12px;" v-if="(this.watch_promo_type == 30 || this.watch_promo_type == 31) && (this.isLabelExternalGameWarningShow || !isCheckRulesByRankingFieldValid)">Make sure you are enter items in ascending order by rank</label>
            <label class="form-control-label" style="color: red; font-size: 12px;" v-if="this.watch_promo_type == 50 && isLabelDefaultRuleWarningShow">Please select at least one default rule, maximum one default rule, and at least one non-default rule</label>
          </div>
          <div class="col-lg-6">
              <label class="form-control-label">
                Trigger
              </label>
              <model-list-select
                :list="selectedTrigger"
                v-model="GlobalPromoModel.trigger_id"
                option-value="id"
                option-text="trigger_name"
                placeholder="select Trigger"
                :isDisabled="isDisabledUpdate"
              >
              </model-list-select>
           </div>          
        </div>

        <div class="row" v-if="IsGameSelectionShow">
          <div class="col-lg-6">
            <label class="form-control-label"> Select Game </label>
            <multiselect
                  v-model="selectedGames"
                  tag-placeholder="Add this as Games"
                  placeholder="select game"
                  label="gameName"
                  track-by="gameId"
                  :options="allGames"
                  :multiple="isMultiSelect"
                  :taggable="true"
                  @remove="unSelectGames"
                  :disabled="isDisabledUpdate"
              >
            </multiselect>
          </div>
        </div>
        <br>
        <div class="row">
          <div class="col-lg-12">
            <div class="form-group has-label">
              <label class="form-control-label"> Start End Date </label>
              <date-picker
                v-model="startEndDate"
                range
                editable
                clearable
                value-type="YYYY-MM-DD"
                id="StartEndDate"
                :default-value="startEndDate"
                style="width: 100%"
                :disabled="isDisabledUpdate"
              ></date-picker>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6" v-if="isGroupShow">
            <div class="form-group has-label">
              <base-input
                alternative=""
                label="Group"
                v-model="GlobalPromoModel.promo_group"
                input-classes="form-control"
                type="text"
                :disabled="isDisabledUpdate"
              />
            </div>
          </div>
        </div>
      </form>
      <template slot="footer">
        <base-button
          type="link"
          class="ml-auto"
          @click="showModalCreate = false"
          >Close/ Cancel
        </base-button>
        <button
          v-on:click="createUpdatePromo"
          class="btn btn-primary"
          v-bind:disabled="disableButtonSubmit"
        >
          Submit
        </button>
      </template>
    </modal>
  </div>
</template>

<script>
import VueBootstrap4Table from "vue-bootstrap4-table";
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import api_loyalty from "../api/api";
// import BaseCheckbox from '../components/BaseCheckbox.vue';
import Multiselect from "vue-multiselect";
import "@/assets/vendor/multiselect/vue-multiselect.min.css";
import "vue2-datepicker/index.css";

export default {
  name: "PromoItemList",
  data() {
    return {
      is_allowed_create: false,
      watch_brand_code: "PHFortune",
      deleteMessages: [],
      showConfirmationModal: false,
      selectedItems: [],
      watch_rules_id : [],
      watch_promo_type : "",
      showActionEdit: false,
      showActionDelete: false,
      brandCodeOption: [],
      allTrigger:[],
      isBrandCodeDisabled: false,
      isPromoTypeDisabled: false,
      isDisabledUpdate: false,
      isEdit : false,
      isLabelUPCInputRegularShow: false,
      isLabelProgressiveMGMShow: false,
      isLabelDailyLoginWarningShow: false,
      isLabelDefaultRuleWarningShow: false,
      isGroupShow: false,
      selectedTrigger:[],
      previousRules:[],
      isRevertingSelectedRules: false,
      isLabelExternalGameWarningShow: false,
      allPromoType: [
        { text: "UGC Artwork Image", value: '0' },
        { text: "UGC Artwork Image - Vote Approved", value: '1' },
        { text: "Spin Wheel - Custom Prize", value: '2' },
        { text: "UPC Input - Lifetime", value: '3' },
        { text: "UPC Custom Insert", value: '4' },
        { text: "MGM Major Prize", value: '5' },
        { text: "MGM Minor Prize", value: '6' },
        { text: "Custom Returnee", value: '7' },
        { text: "Donations", value: '8' },            
        { text: "UPC Input Regular", value: '9' },
        { text: "Cash Or Bukash", value: '11' },             
        { text: "Progressive MGM", value: '12' },
        { text: "Redeem Item", value: '13' },
        { text: "Lucky Promo", value: '14' },
        { text: "Roulette", value: '15' },
        { text: "Daily Login", value: '16' },
        { text: "Auto Awarding Birthday User", value: '17' },
        { text: "Auto Awarding Anniversary", value: '18' },
        { text: "Double SpinWheel", value: '19' },
        { text: "Redeem Item On Event", value: '20' },
        { text: "Daily Check In", value: '25' },
        { text: "Beats Game", value: "30" },
        { text: "Catch Game", value: "31" },
        { text: "Chest Prize", value: '40' },
        { text: "Lucky Promo With SKU", value: '45' },
        { text: "UPC Custom Insert With Raffle", value: '50' }
      ],
      IsMaxChancePerDayShow: false,
      IsMaxWinPerPersonShow: false,
      IsGameSelectionShow: false,
      MaxChancePerDayInputDisabled:true,
      MaxWinPerPersonInputDisabled: true,
      isMultiSelect:true,
      titlePopup: "Create",
      message: null,
      GlobalPromoModel: {
        brand_code: "PHFortune",
        promotion_name: "",
        promotion_type: "",
        trigger_id: "",
        is_giid_only: false,
        max_chance_per_day:0,
        rules_id_list: [],
        addition_rules_id_list:[],
        removal_rules_id_list:[],
        games_id_list: [],
        addition_games_id_list: [],
        removal_games_id_list: [],
        start_date_promo: new Date().toISOString(),
        end_date_promo: new Date().toISOString(),
        create_date: new Date().toISOString(),
        modify_date: new Date().toISOString(),
        promo_group: "",
        max_win_per_person: 0
      },
      TimeZoneConfigValue: "",
      startEndDate: [],
      RulesOption: [],
      selectedRulesOption:[],
      unSelectedRules: [],
      RulesValue:[],
      showModalCreate: false,
      showModalDetail: false,
      rows: [],
      allPromoConfigs: null,
      allGames: [],
      selectedGames: [],
      unSelectedGames: [],
      columns: [
        {
          label: "ID",
          name: "id",
          slot_name: "action_button",
        },
        {
          label: "Brand",
          name: "brand_code",
          sort: true,
        },
        {
          label: "Promotion Name",
          name: "promotion_name",
          sort: true,
        },
        {
          label: "Promotion Type",
          name: "promotion_type_name",
          sort: true,
          filter: {
            type: "simple",
            placeholder: "Enter Promotion Type Name",
            case_sensitive: false, // "false" by default
            showClearButton: true,
            filterOnPressEnter: false,
            debounceRate: 500,
          }          
        },      
        {
          label: "Trigger ID",
          name: "trigger_id",
          sort: true,
        },   
        {
          label: "Is Only Giid Verified",
          name: "is_giid_only",
          slot_name: "is_giid_only_column",
          sort: true,
        },
        {
          label: "Max Chance Per Day",
          name: "max_chance_per_day",
          sort: true,
        },      
        {
          label: "Rules ID",
          name: "rules_id_list",
          sort: true,
        },
        {
          label: "Start Date",
          name: "start_date_promo",
          sort: true,
        },      
        {
          label: "End Date",
          name: "end_date_promo",
          sort: true,
        },                    
      ],
      config: {
        pagination: true,
        pagination_info: true,
        num_of_visibile_pagination_buttons: 7,
        per_page: 10,
        checkbox_rows: true,
        highlight_row_hover: true,
        rows_selectable: true,
        multi_column_sort: false,
        card_mode: false,
        selected_rows_info: true,
        per_page_options: [5, 10, 20, 30],
      },
      classes: {
        table: "table-striped table-bordered",
        row: {
          "my-row my-row2": true,
          "function-class": function(row) {
            return row.id == 1;
          },
        },
      },
    };
  },
  created() {
    this.is_allowed_delete = this.$store.getters.isLoginUserAdmin;
    this.mappingRole();
    this.isBrandCodeDisabled = false;
    this.isPromoTypeDisabled = false;
    this.onRefreshData();
    this.LoadTimezoneConfig();
  },
  methods: {
    mappingRole() {
      let isChe = this.$store.getters.roleMappingData.some(object =>
        object.role.toLowerCase().includes('phche') &&
        object.menu.toLowerCase().includes('promoconfig')
      );
      let isFortune = this.$store.getters.roleMappingData.some(object =>
        object.role.toLowerCase().includes('phft') ||
        object.role.toLowerCase().includes('fortune') &&
        object.menu.toLowerCase().includes('promoconfig')
      );
      let isAdministrator = this.$store.getters.isLoginUserAdmin;
      this.brandCodeOption = [];
      if (isAdministrator || isChe)
      {
        this.brandCodeOption.push({ text: "Chesterfield", value: "PHChe" });
        this.BrandCodeModel = this.ChartBrandCodeModel = "PHChe";
        this.is_allowed_create = true;
        this.is_allowed_delete = true;
        this.watch_brand_code = "PHChe";
      }

      if (isAdministrator || isFortune)
      {
        this.brandCodeOption.push({ text: "Fortune", value: "PHFortune" });
        this.BrandCodeModel = this.ChartBrandCodeModel = "PHFortune";
        this.is_allowed_create = true;
        this.is_allowed_delete = true;
        this.watch_brand_code = "PHFortune";
      }
    },
    LoadTimezoneConfig() {
      api_loyalty.GetTimeZoneConfig(this.watch_brand_code).then((data) => {
        if (data.isSuccess) {
          this.TimeZoneConfigValue = data.data.value;
        }
      });
    },
    resetMessage() {
      this.message = null;
      this.deleteMessages = [];
      this.selectedItems = [];
    },
    onResetForm() {
      this.GlobalPromoModel = {
        id: "",
        brand_code: this.watch_brand_code,
        promotion_name: "",
        promotion_type: "",
        trigger_id: "",
        is_giid_only: false,
        max_chance_per_day:0,
        rules_id_list: [],
        addition_rules_id_list: [],
        removal_rules_id_list:[],
        games_id_list: [],
        addition_games_id_list: [],
        removal_games_id_list: [],
        start_date_promo: new Date().toISOString(),
        end_date_promo: new Date().toISOString(),
        create_date: new Date().toISOString(),
        modify_date: new Date().toISOString(),
        promo_group: "",
      };
      let momNow = this.$moment(new Date().toUTCString());
      let StartDate = momNow.format("YYYY-MM-DD");
      let EndDate = momNow.add(1, "months").format("YYYY-MM-DD");
      let momStart = this.$moment(new Date(StartDate)).format("YYYY-MM-DD");
      let momEnd = this.$moment(new Date(EndDate)).format("YYYY-MM-DD");
      this.startEndDate = [momStart, momEnd];
      this.watch_rules_id = [];
      this.watch_promo_type = ""; 
      this.isBrandCodeDisabled=false;
      this.isPromoTypeDisabled=false;
      this.RulesValue = [];
      this.rulesGet = [];
      this.unSelectedRules= [];
      this.IsMaxChancePerDayShow = false;
      this.IsMaxWinPerPersonShow = false;
      this.isDisabledUpdate = false;
    },
    onCreateNewPromo() {
      this.showModalCreate = true;
      this.titlePopup = "Create";
      this.isBrandCodeDisabled = false;
      this.isPromoTypeDisabled = false;
      this.isEdit = false;
      this.onResetForm();
    },
    onRefreshData() {
      this.watch_rules_id=[];
      api_loyalty
        .GetAllPromoConfig(this.watch_brand_code)
        .then((data) => {
        try {
          if(data.isSuccess){
            data.data.forEach(function (item){
              switch(item.promotion_type){
                case "0": item.promotion_type_name = "UGC Artwork Image"; break;
                case "1": item.promotion_type_name = "UGC Artwork Image - Vote Approved"; break;
                case "2": item.promotion_type_name = "Spin Wheel - Custom Prize"; break;
                case "3": item.promotion_type_name = "UPC Input - Lifetime"; break;
                case "4": item.promotion_type_name = "UPC Custom Insert"; break;
                case "5": item.promotion_type_name = "MGM Major Prize"; break;
                case "6": item.promotion_type_name = "MGM Minor Prize"; break;
                case "7": item.promotion_type_name = "Custom Returnee"; break;
                case "8": item.promotion_type_name = "Donations"; break;
                case "9": item.promotion_type_name = "UPC Insert Regular"; break;           
                case "11": item.promotion_type_name = "Cash or Bukash"; break;              
                case "12": item.promotion_type_name = "Progressive MGM"; break; 
                case "13": item.promotion_type_name = "Redeem Item"; break;
                case "14": item.promotion_type_name = "Lucky Promo"; break;
                case "15": item.promotion_type_name = "Roulette"; break;
                case "16": item.promotion_type_name = "Daily Login"; break;
                case "17": item.promotion_type_name = "Auto Awarding Birthday User"; break;
                case "18": item.promotion_type_name = "Auto Awarding Anniversary"; break;
                case "19": item.promotion_type_name = "Double SpinWheel"; break;
                case "20": item.promotion_type_name = "Redeem Item On Event"; break;

                case "25": item.promotion_type_name = "Daily Check In"; break;
                case "30": item.promotion_type_name = "Beats Game"; break;
                case "31": item.promotion_type_name = "Catch Game"; break;
                case "40": item.promotion_type_name = "Chest Prize"; break;
                case "45": item.promotion_type_name = "Lucky Promo With SKU"; break;
                case "50": item.promotion_type_name = "UPC Custom Insert With Raffle"; break;
              }
            });          
            this.rows = data.data;
            this.allPromoConfigs = data.data;
          }
        } catch (e) {
          console.log(e);
        }
      });

      api_loyalty
        .GetAllRules(this.watch_brand_code)
        .then((data) => {
        try {
          if(data.isSuccess){
            this.RulesOption = data.data;
          }
        } catch (e) {
          console.log(e);
        }
      });
      
      api_loyalty.GetAllTrigger(this.watch_brand_code).then((data) => {
      try {
        if(data.isSuccess){
          this.allTrigger = data.data;
        }
      } catch (e) {
        console.log(e);
      }
      });
    },
    onSelectRow(payload) {
      this.showActionEdit = true;
      this.showActionDelete = true;
      this.selectedItems = payload.selected_items;
      if (payload.selected_items.length == 0) {
        this.showActionEdit = false;
        this.showActionDelete = false;
      }
      if (payload.selected_items.length > 1) {
        this.showActionEdit = false;
      }
    },
    onEditRow() {
      this.unSelectedRules= [];
      
      ////get selected config to be edited and assign the object into property GlobalPromoModel
      const selectedConfig = this.allPromoConfigs.find(
          (x) => x.id === this.selectedItems[0].id
        ) ?? {};
      
      ////logic to handling is_giid_only as the expected value is boolean, meanwhile api returning 0/1
      ////this logic is necessary otherwise the es-lint will complain as the there is data type inconsistency
      selectedConfig.is_giid_only = selectedConfig.is_giid_only == 0 ? false : true; 

      this.GlobalPromoModel = Object.assign(
        this.GlobalPromoModel,
        selectedConfig
      );

      this.showModalCreate = true;
      this.isBrandCodeDisabled = true;
      this.isPromoTypeDisabled = true;
      this.titlePopup = "Update";
      this.watch_promo_type = this.GlobalPromoModel.promotion_type;
      this.visiblityToggle(this.GlobalPromoModel.promotion_type);
      this.disabilityToggle(this.GlobalPromoModel.promotion_type);
      
      var start_date = new Date(this.GlobalPromoModel.start_date_promo);

      //ada perbedaan antara get tgl dr dynamo dan mysql.
      var hours = start_date.getHours() + parseInt(this.TimeZoneConfigValue) * 2;
      start_date.setHours(
        hours
      );
      var end_date = new Date(this.GlobalPromoModel.end_date_promo);
      end_date.setHours(
        hours
      );

      this.isDisabledUpdate = start_date < new Date();
      this.startEndDate = [start_date.toISOString(), end_date.toISOString()];

      var list_options = this.RulesOption;
      let rules_items = [];
      this.GlobalPromoModel.rules_id_list.forEach(function (item) {
        var rules_item = list_options.filter((x) => x.id === item)[0];
        if(rules_item){
          rules_items.push(rules_item);
        }
      });
      this.RulesValue = rules_items;
      this.rulesGet = rules_items;
      this.isEdit = true;
      this.previousRules = this.RulesValue;
      this.watch_rules_id = this.previousRules;
    },
    onDeleteRow() {
      this.selectedItems.forEach((element) => {
        let deleteRequest = {
          id: element.id,
        };
        this.GlobalPromoModel.id = deleteRequest.id;
        this.GlobalPromoModel.brand_code = this.watch_brand_code;

        api_loyalty
          .DeleteGlobalPromoConfig(this.GlobalPromoModel.brand_code, this.GlobalPromoModel)
          .then((response) => {
            var popupType = "success"
            if(response.isSuccess == false){
            popupType = "danger";
          }
            this.onRefreshData();
            let msg = {
              message:
              response.message + " : " + element.promotion_name + "'.",
              type: popupType
            };
            this.deleteMessages.push(msg);
          })
          .catch((e) => {
            console.log(e);
            var msg = {
              message:
                "Failed to delete Promo '" +
                element.promotion_name +
                "'.",
              type: "danger",
            };

            if (e.response && e.response.status === 401)
            {
              msg = {
                message: "You don't have a permission",
                type: 'danger'
              }
            }
            this.deleteMessages.push(msg);
          });
      });
      this.showConfirmationModal = false;
    },
    insertUpdatepromoMethod(){
      var prevRules = [];
      if(this.isMultiSelect == false){
        this.previousRules.forEach(function (item) {
          prevRules.push(item.id);
        });
        this.GlobalPromoModel.removal_rules_id_list = prevRules;
      }

      if(!this.GlobalPromoModel.max_win_per_person)
      this.GlobalPromoModel.max_win_per_person = 0
      
      if (this.GlobalPromoModel.id) {
        this.GlobalPromoModel.brand_code = this.watch_brand_code;

        //compare id on removal list with addition list
        var compareRemovalId = this.GlobalPromoModel.removal_rules_id_list.filter(val => !this.GlobalPromoModel.addition_rules_id_list.includes(val));
        this.GlobalPromoModel.removal_rules_id_list = compareRemovalId;
        var compareRemovalGamesId = this.GlobalPromoModel.removal_games_id_list.filter(val => !this.GlobalPromoModel.addition_games_id_list.includes(val));
        this.GlobalPromoModel.removal_games_id_list = compareRemovalGamesId;
        api_loyalty
        .UpdateGlobalPromoConfig(this.GlobalPromoModel.brand_code, this.GlobalPromoModel)
        .then((response) => {
          this.onRefreshData();
          var popupType = "success"
          if(response.isSuccess == false){
            popupType = "danger";
          }

          this.message = {
            message: response.message,
            type: popupType,
          };
        })
        .catch((e) => {
          console.log(e);
          if (e.response && e.response.status === 401)
          {
            this.message = {
              message: "You don't have a permission",
              type: 'danger'
            }
          } else
          {
            this.message = {
              message: "Failed to update Promo.",
              type: "danger",
            }
          }
        });
      } else {
        this.GlobalPromoModel.brand_code = this.watch_brand_code;

        api_loyalty
        .AddGlobalPromoConfig(this.GlobalPromoModel.brand_code, this.GlobalPromoModel)
        .then((response) => {
          this.onRefreshData();
          var popupType = "success"
          if(response.isSuccess == false){
            popupType = "danger";
          }

          this.message = {
            message: response.message,
            type: popupType,
          };
        })
        .catch((e) => {
          console.log(e);
          if (e.response && e.response.status === 401)
          {
            this.message = {
              message: "You don't have a permission",
              type: 'danger'
            }
          } else
          {
            this.message = {
              message: "Failed to create Promo.",
              type: "danger",
            }
          }
        });
      }
    },
    createUpdatePromo() {

      let rules_items = [];
      let rules_items_get = [];
      this.GlobalPromoModel.brand_code = this.watch_brand_code;

      this.rulesGet.forEach(function (item) {
          rules_items_get.push(item.id);
      });

      if(this.RulesValue[0] != undefined){
        this.RulesValue.forEach(function (item) {
            rules_items.push(item.id);
        });
      }else{
        rules_items.push(this.RulesValue.id);
      }

      this.GlobalPromoModel.addition_rules_id_list = rules_items;
      this.GlobalPromoModel.addition_games_id_list = this.selectedGames
        .filter(item => item && item.gameId)
        .map(item => item.gameId);

      if (this.startEndDate.length > 1) {
        this.GlobalPromoModel.start_date_promo = new Date(
          this.startEndDate[0]
        ).toISOString();
        this.GlobalPromoModel.end_date_promo = new Date(
          this.startEndDate[1]
        ).toISOString();
      }
      try {
          api_loyalty
          .CheckValidPromoDate(this.GlobalPromoModel.brand_code, 
                              this.GlobalPromoModel.promotion_type,
                              this.GlobalPromoModel.id,
                              this.GlobalPromoModel.start_date_promo,
                              this.GlobalPromoModel.end_date_promo,
                              this.GlobalPromoModel.promo_group)
          .then((data) => {
            if(data.isSuccess)
            {
              var ActivePromo = data.data;   
              if(ActivePromo.promo_id == null){
                if(this.GlobalPromoModel.promotion_type == 1 || this.GlobalPromoModel.promotion_type == 6){
                  if(ActivePromo.is_coupled_promo_exist){
                    this.insertUpdatepromoMethod();
                    this.onResetForm();
                    this.showModalCreate = false;
                  }else{
                      this.onRefreshData();
                      this.showModalCreate = false;
                      this.message = {
                        message:
                          "Please create the main promotion first "
                          ,
                        type: "danger",
                      };
                  }
                }else{
                  this.insertUpdatepromoMethod();
                  this.onResetForm();
                  this.showModalCreate = false;
                }

              }else{
                this.onRefreshData();
                this.showModalCreate = false;
                this.message = {
                  message:
                    "Choose a different date range, because the date is already in use by " +
                    ActivePromo.promo_name,
                  type: "danger",
                };
              }
            }
          })
      } catch (e) {
        console.log(e);
        this.message = {
          message: "Failed to add/update promo.",
          type: "danger",
        };
      }
    },
    unSelectItem({id}){
      if(this.unSelectedRules.indexOf(id) == -1){
        this.unSelectedRules.push(id);
        this.GlobalPromoModel.removal_rules_id_list.push(id);
      }
    },
    unSelectGames({gameId}){
      if(this.unSelectedGames.indexOf(gameId) == -1){
        this.unSelectedGames.push(gameId);
        this.GlobalPromoModel.removal_games_id_list.push(gameId);
      }
    },
    multiSelectToggle(promo_type){
      //define the default, false means not multi select
      this.isMultiSelect = false;

      switch(promo_type){
        case '0':
        case '1':
        case '3':
        case '5':
        case '6':
        case '7':
          break;
        case '2':
        case '4':
        case '8':  
        case '9':
        case '11':  
        case '12':  
        case '13':
        case '20':
        case '15':
        case '19':
        case '16':
        case '25':
        case '30':
        case '31':
        case '17':
        case '18':
        case '40':
        case '50':
          this.isMultiSelect = true;
          break;
        default:
          this.isMultiSelect = false;
        break;
      }
    },
    visiblityToggle(promo_type){
      //define the default, all false means not visible
      this.IsMaxChancePerDayShow = false;
      this.isLabelUPCInputRegularShow = false;
      this.isLabelProgressiveMGMShow = false;
      this.isLabelDefaultRuleWarningShow = false;
      this.isGroupShow = false;
      this.IsMaxWinPerPersonShow = false;
      this.IsGameSelectionShow = false;
      
       switch(promo_type){
        case '0':
        case '1':
        case '3':
        case '5':
        case '6':
        case '7':
        case '8': 
        case '11':
        case '13':
        case '14':
        case '16':
        case '17':
        case '18':
        case '25':
        case '40':
          break;
        case '50':
          this.IsMaxChancePerDayShow = true;
          break;
        case '2':
        case '4':
          this.IsMaxChancePerDayShow = true;
          break;
        case '9':
          this.IsMaxChancePerDayShow = true;
          this.isLabelUPCInputRegularShow = true;
          break;
        case '12':
          this.isLabelProgressiveMGMShow = true;
          break;
        case '15':
          this.IsMaxChancePerDayShow = true;
          break;
        case '19':
           this.isGroupShow = true;
           this.IsMaxWinPerPersonShow = true;
           break;
        case '20':
           this.isGroupShow = true;
           this.IsMaxWinPerPersonShow = true;
           break;
        case '30':
        case '31':
          this.IsGameSelectionShow = true;
          this.IsMaxChancePerDayShow = true;
           break;
       }
    },
    disabilityToggle(promo_type){
      //define the default, all true means disabled
      this.MaxChancePerDayInputDisabled = true;
      this.MaxWinPerPersonInputDisabled = true;

      switch(promo_type){
        case '0':
        case '1':
        case '3':
        case '5':
        case '6':
        case '7':
        case '17':
        case '18':  
          this.GlobalPromoModel.max_chance_per_day = 0;
          break;
        case '50':
          this.MaxChancePerDayInputDisabled = false;
          break;
        case '8':
          this.is_slice_free_spin = false;
          this.is_slice_try_again= false;
          break;
        case '2':
        case '4':
        case '9':
        case '15':
        case '30':
        case '31':
          this.MaxChancePerDayInputDisabled = false;
          break;
        case '19':
        case '20':
          this.MaxWinPerPersonInputDisabled = false;
        break;
       }
    },
    async getAllGames(){
      try
      {
        const allGamesResponse = await api_loyalty.GetAllGames(this.watch_brand_code, "");
        if(allGamesResponse.isSuccess)
        {
          let gameGroup = this.watch_promo_type == 30 ? "BeatsGame" : "CatchGame";
          this.allGames = allGamesResponse.data
            .filter(x => x.game_group == gameGroup)
          .map(s => ({
            gameId: s.id,
            gameType: s.game_type,
            gameGroup: s.game_group,
            gameName: s.game_name + " - " + s.game_type
          }));
        }
      } catch (e)
      {
        console.log(e);
      }
    },
    validateSelectedRule(promotion_type, selectedRules) {

      ////logic to handle infinite update loop in watcher for reactive array (selectedRules) of vue
      ////every logic that mutate the reactive array (selectedRules) need to set this.isRevertingSelectedRules = true;
      if (this.isRevertingSelectedRules) {
        ////if the current execution is coming from previous invocation and was mutating reactive array
        ////then directly stop the execution and set the isRevertingSelectedRules to default value (this.isRevertingSelectedRules = false)
        this.isRevertingSelectedRules = false;
        return;
    }
      else {
        this.isLabelExternalGameWarningShow = false;
        this.isLabelDailyLoginWarningShow = false;
        this.isLabelDefaultRuleWarningShow = false;
      }

      if(promotion_type == "9")
      {
          if(selectedRules.filter(a => a.sub_promotion_type == "0").length > 1){
            selectedRules.pop();
            this.isRevertingSelectedRules = true;
          }
      }

      if(promotion_type == "16")
      {
        for (const subPromo of ["4", "5"]) {
          const lastVal = selectedRules[selectedRules.length - 1];
          if (selectedRules.filter(a => a.sub_promotion_type == subPromo && a.input_count == lastVal.input_count).length > 1)
          {
            selectedRules.pop();
            this.isLabelDailyLoginWarningShow = true;
            this.isRevertingSelectedRules = true;
          } 
        }
      }

      if(promotion_type == "25")
      {
        for (const subPromo of ["10", "11"]) {
          const lastVal = selectedRules[selectedRules.length - 1];
          if (selectedRules.filter(a => a.sub_promotion_type == subPromo && a.input_count == lastVal.input_count).length > 1)
          {
            selectedRules.pop();
            this.isLabelDailyLoginWarningShow = true;
            this.isRevertingSelectedRules = true;
          } 
        }
      }

      if(promotion_type == "12") {
        //get last element of val array to check if there are more than one value input_count in the val array
        var valLastElement = selectedRules[selectedRules.length - 1];
        if(selectedRules.filter(a => a.input_count == valLastElement.input_count).length > 1){
            selectedRules.pop();
            this.isRevertingSelectedRules = true;
        }
      }

      ////For BeatsGame and CatchGame
      if(promotion_type == "30" || promotion_type == "31")
      {
        ////only 1 ReservedWinner rule and 1 Completion rule is allowed
        if(selectedRules.filter(s => s.sub_promotion_type == "7").length > 1 
        || selectedRules.filter(s => s.sub_promotion_type == "8").length > 1){
          ////remove the recent added ReservedWinner rule and Completion rule
          selectedRules.pop();
          this.isRevertingSelectedRules = true;
        }

        ////Validate whether the rank sequence is correct or not
        ////need to exclude the Completion rule for the rank sequence checking as Completion rule has rank 0
        var selectedRulesExceptCompletionRule = selectedRules.filter(s => s.rank != 0);
        let validationRank = this.validateRanks(selectedRulesExceptCompletionRule);
        if(!validationRank.isValid){
            ////remove all invalid LeaderboardWinner rules
            const filteredValidRulesByRankField = selectedRules.filter(item => !validationRank.invalidRanks.includes(item.rank));
            selectedRules.splice(0, selectedRules.length, ...filteredValidRulesByRankField);
            this.isLabelExternalGameWarningShow = true,
            this.isRevertingSelectedRules = true;
        }
      }

      ////For UPC Custom Insert With Raffle (promotion type 50)
      if(promotion_type == "50")
      {
        ////Check if more than one rule with default_rule is selected
        const defaultRules = selectedRules.filter(s => s.default_rule == 1);
        if(defaultRules.length > 1){
          selectedRules.pop();
          this.isRevertingSelectedRules = true;
        }
        
        ////Show warning if there is no non-default rule selected
        const nonDefaultRules = selectedRules.filter(s => s.default_rule != 1);
        if((defaultRules.length === 0 && selectedRules.length > 0) || 
           (defaultRules.length > 0 && nonDefaultRules.length === 0)){
          this.isLabelDefaultRuleWarningShow = true;
        } else {
          this.isLabelDefaultRuleWarningShow = false;
        }
      }
  },
    validateRanks(selectedRules) {
      // Handle edge case of an empty array.
      if (!selectedRules || selectedRules.length === 0) {
        return {
          isValid: false,
          invalidRanks: []
        };
      }

      const numItems = selectedRules.length;
      const ranks = selectedRules.map(item => item.rank);

      // Use a Set to find duplicate ranks efficiently.
      const uniqueRanks = new Set(ranks);
      const duplicates = ranks.filter(rank => {
        if (uniqueRanks.has(rank)) {
          uniqueRanks.delete(rank);
        } else {
          return true;
        }
        return false;
      });

      // Find missing ranks by comparing the sorted list with an ideal sequence.
      const sortedRanks = ranks.sort((a, b) => a - b);
      const missingRanks = [];
      const expectedRank = 1;
      for (let i = 0; i < sortedRanks.length; i++) {
        if (sortedRanks[i] !== expectedRank + i) {
          // The current rank is not what's expected in a consecutive sequence.
          missingRanks.push(sortedRanks[i]);
        }
      }

      // Combine all types of invalid ranks into a single list.
      const invalidRanks = [...duplicates, ...missingRanks];

      // The ranks are valid only if there are no duplicates and no missing ranks.
      const isValid = duplicates.length === 0 && missingRanks.length === 0 && sortedRanks[0] === 1 && sortedRanks[sortedRanks.length - 1] === numItems;

      return {
        isValid,
        invalidRanks
      };
    }
  },
  components: {
    VueBootstrap4Table,
    ModelListSelect,
    Multiselect,
    // BaseCheckbox,
  },
  watch: {
    watch_brand_code: function(val) {
      this.GlobalPromoModel.brand_code = this.watch_brand_code;
      this.watch_promo_type = "";
      api_loyalty.GetAllTrigger(this.watch_brand_code).then((data) => {
        try {
          if(data.isSuccess){
            this.allTrigger = data.data;
            this.selectedTrigger = data.data;
          }
        } catch (e) {
          console.log(e);
        }
      });

      api_loyalty
        .GetAllRules(this.watch_brand_code)
        .then((data) => {
        try {
          if(data.isSuccess){
            this.RulesOption = data.data;
            this.selectedRulesOption = data.data;
          }
        } catch (e) {
          console.log(e);
        }
      });
      switch (val) {
        case "PHChe":
          this.allMerchants = this.CheMerchants;
          break;
        default:
          this.allMerchants = this.FortuneMerchants;
          break;
      }
      this.onRefreshData();
    },
    watch_rules_id: function(val){
      this.validateSelectedRule(this.GlobalPromoModel.promotion_type, val);
      this.RulesValue = val;
    },
    watch_promo_type: async function (val) {
      var trigger_items = []
      var rules_items = []

      if(!this.isEdit){
        this.GlobalPromoModel.trigger_id = "";
      }

      this.GlobalPromoModel.promotion_type = val;
      this.allTrigger.forEach(function (item) {
        if(item.promotion_type == val ){
          trigger_items.push(item);
        }
      });
      this.selectedTrigger = trigger_items;
      this.RulesOption.forEach(function (item) {
        if(item.promotion_type == val ){
          rules_items.push(item);
        }
      });
      this.selectedRulesOption = rules_items;
      if( this.isEdit == false){
        this.RulesValue = [];
        this.watch_rules_id = [];
          if (rules_items.length==0)
          {
              this.selectedRulesOption=[];
              this.watch_sub_promo_type=[];
          }
      }
      this.isEdit = false;

      //for multi select
      this.multiSelectToggle(val);

      //visibility input field
      this.visiblityToggle(this.GlobalPromoModel.promotion_type);
      this.disabilityToggle(this.GlobalPromoModel.promotion_type);
      
      if(val !== "16" && val !== "25") {
        this.isLabelDailyLoginWarningShow = false;
      }

        this.allGames = [];
        this.selectedGames = [];
      if (val == "30" || val == "31") {
        await this.getAllGames();
        this.selectedGames = this.allGames.filter((item) =>
          this.GlobalPromoModel.games_id_list.includes(item.gameId)
        );
      }
    },
  },
  computed: {
    isCheckRulesByRankingFieldValid: function() {
      const selectedRulesExceptCompletionRule = this.RulesValue.filter(s => s.rank != 0);
      return this.validateRanks(selectedRulesExceptCompletionRule).isValid;
    },
    disableButtonSubmit: function () {
      let isDisabled = false;
       if(this.GlobalPromoModel.promotion_name &&
          this.GlobalPromoModel.trigger_id &&
          this.GlobalPromoModel.promotion_type &&
          (this.RulesValue.length > 0 || this.RulesValue.id != null) &&
          !this.isDisabledUpdate)
        {
          isDisabled = false;
          if (this.GlobalPromoModel.promotion_type == '15') {
           let isTryAgain = this.RulesValue.find(x => x.is_slice_try_again == 1);
           console.log(isTryAgain)
             if (this.RulesValue.length > 4 && this.RulesValue.length <= 9 && isTryAgain != undefined) {
               isDisabled = false;
             } else {
               isDisabled = true;
             }
           }
        }
        else
        {
          isDisabled = true;
        }

      ////PromoType BeatsGame and CatchGame
      if(!isDisabled && (this.GlobalPromoModel.promotion_type == "30" || this.GlobalPromoModel.promotion_type == "31"))
      {
        if(this.selectedGames.length <= 0)
        {
          isDisabled = true;
        }

        if(!this.isCheckRulesByRankingFieldValid){
          isDisabled = true;
        }
      }

      ////PromoType UPC Custom Insert With Raffle (50)
      if(!isDisabled && this.GlobalPromoModel.promotion_type == "50")
      {
        const defaultRules = this.RulesValue.filter(s => s.default_rule == 1);
        const nonDefaultRules = this.RulesValue.filter(s => s.default_rule != 1);
        
        if(defaultRules.length === 0){
          isDisabled = true;
        }
        else if(nonDefaultRules.length === 0){
          isDisabled = true;
        }
      }

      return isDisabled;
    }
  }
};
</script>
<style>
</style>

